Reflux = require 'reflux'

module.exports = Reflux.createActions ['showNavigation', 'hideNavigation', 'darkMode', 'lightMode', 'hideLogo', 'showLogo', 'disableAnimations', 'enableAnimations']



/** WEBPACK FOOTER **
 ** ./src/scripts/actions/navigation.coffee
 **/